import React from 'react';
import RegisterInterest from '../../components/modals/RegisterInterest/RegisterInterest';

const VMSServices: React.FC = () => {
  return (
    <>
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">
            VMS <span className="hero-highlight">services</span>
          </h1>
          <p className="about-hero-subtitle">
            Bringing data to where decisions are made.
          </p>
        </div>
      </section>

      {/* Concept, One-Click, and product cards in a single grid */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-grid">
            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-diagram-3"></i>
              </div>
              <h3>Integrations for VMS customers</h3>
              <p>
                We help customers of VMS systems such as IMOS and Dataloy build
                integrations that bring external data directly into the platforms
                they already work in.
              </p>
              <p>
                To be truly data-driven, data has to live where the decision is
                made. Reports in PowerBI or extra logins to other tools are not
                enough — by the time the analyst has switched windows, the
                decision has already been made on instinct. We close that gap.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-mouse"></i>
              </div>
              <h3>One-Click Concept</h3>
              <p>
                Inside your VMS, you see the essentials — the numbers that
                matter for the decision at hand, embedded directly in the
                workflow. No extra dashboards, no extra logins.
              </p>
              <p>
                When you need the deeper picture — the assumptions, the
                breakdown, the underlying data — a single click takes you
                straight from the VMS into our detailed views.
              </p>
            </div>
          </div>

          <h2 className="product-v2-section-title" style={{ marginTop: '4rem' }}>Available Services</h2>
          <p className="product-v2-section-subtitle">
            Both services can be set up in your VMS within 15 minutes.
          </p>

          <div className="about-grid">
            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-cloud-sun"></i>
              </div>
              <h3>Weather Factor</h3>
              <p>
                Statistical weather impact for any voyage leg, ready to feed
                into your VMS at pre-fix.
              </p>
            </div>

            <div className="about-card">
              <div className="about-card-icon">
                <i className="bi bi-cloud-rain"></i>
              </div>
              <h3>Weather in Port</h3>
              <p>
                Statistical port weather focused on what actually delays
                operations — rain duration and frequency, not millimetres.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Detail sections with images */}
      <section className="product-section" style={{ paddingTop: 0 }}>
        <div className="product-container">
          <div className="product-feature">
            <div className="product-feature-image">
              <img src="/assets/weatherfactor.png" alt="Weather Factor" />
            </div>
            <div className="product-feature-content">
              <h3>Weather Factor in detail</h3>
              <p>
                Weather Factor is built on 10 years of historical weather data
                combined with advanced models to estimate the weather impact a
                vessel will see across a given route at a given time of year.
              </p>
              <p>
                Because it is a statistical pre-fix model — not a forecast — it
                gives a stable, defensible expectation that fits naturally into
                the assumptions behind a voyage estimate.
              </p>
            </div>
          </div>

          <div className="product-feature product-feature-reverse">
            <div className="product-feature-image">
              <img src="/assets/weatherinport.png" alt="Weather in Port" />
            </div>
            <div className="product-feature-content">
              <h3>Weather in Port in detail</h3>
              <p>
                Weather in Port draws on more than 40 million data points
                spanning 10 years of historical weather, but answers a different
                question than most weather services. Most tell you how much it
                rains. For port operations, that is rarely the number that
                matters.
              </p>
              <p>
                What matters is <strong>how long</strong> it rains,{' '}
                <strong>how often</strong> it rains, and{' '}
                <strong>how long until the first rain</strong> when rain
                arrives. Those are the numbers that drive cargo delays,
                demurrage exposure, and stoppages — and they are the numbers
                Weather in Port reports.
              </p>
              <p>
                Like Weather Factor, it is a statistical model intended for
                pre-fix decisions, not a short-term forecast.
              </p>
            </div>
          </div>

          <div className="about-cta" style={{ borderTop: 'none' }}>
            <p className="about-cta-text">
              Want to bring this data into your VMS?
            </p>
            <RegisterInterest
              showSubtext={false}
              buttonLabel="Get in touch"
              buttonClassName="btn-about-cta"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default VMSServices;
